/* eslint-disable react/require-default-props */
import React from "react";
import moment from "moment";
import { TrueLinkCreditReportType } from "types";
import InquiriesIcon from "assets/credit-report/inquiries.svg";
import { Accordion } from "./Accordion";

interface CreditReportInquiriesProps {
  inquiries: TrueLinkCreditReportType["InquiryPartition"];
  className?: string;
}

export const CreditReportInquiries = (props: CreditReportInquiriesProps) => {
  const { inquiries = [], className } = props;

  return (
    <div className={className}>
      <div>
        <h2 className="text-2xl font-bold flex items-center">
          <img alt="" src={InquiriesIcon} className="inline mr-2" />
          Credit Inquiries
        </h2>
        <div className="mt-4 space-y-6">
          {inquiries.map((inquiryPartition) => {
            const inquiry = inquiryPartition?.Inquiry?.[0];
            if (!inquiry) {
              return null;
            }
            return (
              <Accordion
                key={inquiry.$?.subscriberNumber}
                className="mt-4"
                details={[
                  {
                    title: "Inquiry Type",
                    value: inquiry.$?.inquiryType || "N/A",
                  },
                  {
                    title: "Inquiry Date",
                    value: inquiry.$?.inquiryDate
                      ? moment(inquiry.$?.inquiryDate).format("MM/DD/YYYY")
                      : "N/A",
                  },
                ]}
                title="Inquiry detail"
              >
                <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                    <p>{inquiry.$?.subscriberName}</p>
                    <p className="text-xs font-normal text-neutral-600">
                      Requested{" "}
                      {moment(inquiry.$.inquiryDate).format("MM/DD/YYYY")}
                    </p>
                  </div>
                </div>
              </Accordion>
            );
          })}
        </div>
      </div>
    </div>
  );
};
